import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f249f7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "line-info-list-container",
  ref: "containerRef"
}
const _hoisted_2 = {
  class: "list-header",
  ref: "headerRef"
}
const _hoisted_3 = { class: "header-contents" }
const _hoisted_4 = { class: "bus-stop-info" }
const _hoisted_5 = { class: "bus-stop--name" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom-line" }, null, -1 /* HOISTED */))
const _hoisted_8 = {
  class: "line-info-wrapper",
  role: "list",
  "aria-label": "노선 목록",
  ref: "scrollContainer"
}
const _hoisted_9 = ["aria-label", "onClick", "onKeydown"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, " 즐겨찾기를 삭제하시면 설정하신 모든 정보가 삭제됩니다. 즐겨찾기를 삭제하시겠습니까? ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString($props.busStop.name), 1 /* TEXT */)
        ]),
        _createElementVNode("button", {
          class: "fav-btn",
          type: "button",
          "aria-label": 
            $setup.isFavorite($props.busStop.id) ? '즐겨찾기 해제' : '즐겨찾기 추가'
          
        }, [
          ($setup.isFavorite($props.busStop.id))
            ? (_openBlock(), _createBlock($setup["InlineSvg"], {
                key: 0,
                class: "img-fav fill",
                src: require('@/assets/icons/star-filled.svg'),
                alt: "즐겨찾기 해제",
                "aria-hidden": "true",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowAlertToDeleteFavorite(true)))
              }, null, 8 /* PROPS */, ["src"]))
            : (_openBlock(), _createBlock($setup["InlineSvg"], {
                key: 1,
                class: "img-fav empty",
                src: require('@/assets/icons/star-empty.svg'),
                alt: "즐겨찾기 추가",
                "aria-hidden": "true",
                onClick: $setup.addFavoriteBusStop
              }, null, 8 /* PROPS */, ["src"]))
        ], 8 /* PROPS */, _hoisted_6)
      ]),
      _hoisted_7
    ], 512 /* NEED_PATCH */),
    _createElementVNode("ul", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.lineInfos, (lineInfo) => {
        return (_openBlock(), _createElementBlock("li", {
          key: lineInfo.id,
          role: "link",
          tabindex: "0",
          "aria-label": `노선 상세: ${lineInfo.lineNameDisplayText} 페이지로 이동`,
          onClick: ($event: any) => ($setup.goToLineInfoDetail(lineInfo)),
          onKeydown: _withKeys(_withModifiers(() => $setup.goToLineInfoDetail(lineInfo), ["prevent"]), ["enter"])
        }, [
          _createVNode($setup["LineInfoRow"], {
            lineInfo: lineInfo,
            busStop: $props.busStop
          }, null, 8 /* PROPS */, ["lineInfo", "busStop"])
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_9))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512 /* NEED_PATCH */),
    ($setup.scrollContainer)
      ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
          key: 0,
          container: $setup.scrollContainer
        }, null, 8 /* PROPS */, ["container"]))
      : _createCommentVNode("v-if", true),
    ($setup.shouldShowAlertToDeleteFavorite)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 1,
          title: "즐겨찾기 삭제",
          okButtonTitle: "삭제하기",
          cancelButtonTitle: "취소",
          onOnClickOkButton: _cache[1] || (_cache[1] = ($event: any) => (
        [$setup.toggleShowAlertToDeleteFavorite(false), $setup.removeFavoriteBusStop()]
      )),
          onOnClickCancelButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowAlertToDeleteFavorite(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}